module.exports = __webpack_public_path__ + "static/media/crown_touch4.fdbb4b44.jpg";